export enum POSVendor {
  CONNECTOR = 'CONNECTOR',
  NCR = 'NCR',
  QST = 'QST',
  SICOM = 'SICOM',
  PARTNER = 'PARTNER',
  PRODUCT_NUMBER = 'PRODUCT_NUMBER',
  QDI = 'QDI',
  RPOS = 'RPOS',
}

export enum PLUPosVendors {
  BRINK = 'brink',
  CARROLS = 'carrols',
  HDX = 'hdx',
  NCR = 'ncr',
  OHEICS = 'oheics',
  PARTNER = 'partner',
  PRODUCT_NUMBER = 'productNumber',
  QDI = 'qdi',
  QST = 'qst',
  RPOS = 'rpos',
  SICOM = 'sicom',
  SIMPLY = 'simply',
  SIMPLY_DELIVERY = 'simplyDelivery',
  TOSHIBA_LOYALTY = 'toshibaLoyalty',
  XENIAL = 'xenial',
}
